var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2079_13586)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0002 14C22.8406 14 21.8953 14.9079 21.8364 16.048H26.1639C26.105 14.9079 25.1597 14 24.0002 14ZM24.0002 13C22.2901 13 20.8951 14.3536 20.8355 16.048H16.5C16.2239 16.048 16 16.2719 16 16.548C16 16.8241 16.2239 17.048 16.5 17.048H17.549L18.9068 29.6627C18.9888 30.4245 19.6318 31.0021 20.3981 31.0021H27.6019C28.3682 31.0021 29.0112 30.4245 29.0932 29.6627L30.451 17.048H31.5C31.7761 17.048 32 16.8241 32 16.548C32 16.2719 31.7761 16.048 31.5 16.048H27.1648C27.1052 14.3536 25.7102 13 24.0002 13ZM19.901 29.5556L18.5567 17.0663H29.4433L28.099 29.5556C28.0717 29.8096 27.8573 30.0021 27.6019 30.0021H20.3981C20.1427 30.0021 19.9283 29.8096 19.901 29.5556ZM23 20.1631C23 19.887 22.7761 19.6631 22.5 19.6631C22.2239 19.6631 22 19.887 22 20.1631L22 26.3891C22 26.6653 22.2239 26.8891 22.5 26.8891C22.7761 26.8891 23 26.6653 23 26.3891L23 20.1631ZM25.5 19.6631C25.7761 19.6631 26 19.887 26 20.1631V26.3891C26 26.6653 25.7761 26.8891 25.5 26.8891C25.2239 26.8891 25 26.6653 25 26.3891L25 20.1631C25 19.887 25.2239 19.6631 25.5 19.6631Z",
    fill: "#E51717"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2079_13586",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.192157 0 0 0 0 0.2 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_13586"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.192157 0 0 0 0 0.2 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2079_13586",
    result: "effect2_dropShadow_2079_13586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2079_13586",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelete);
export default __webpack_public_path__ + "static/media/ico-delete.ee2600e7db659556c4ca5860b2f8f367.svg";
export { ForwardRef as ReactComponent };